import React, {useEffect, useState} from 'react';
import PostFooterSocial from '@components/blog/PostFooter';
import * as styles from './style.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import {useTranslation} from 'gatsby-plugin-react-i18next';
const {
    postSidebar,
    postSidebarFixed,
    postSidebarBottom,
    postSidebar__toc,
    postSidebar__links,
    postSidebar__link,
    postSidebar__linkActive,
    postSidebar__title,
    postSidebar__topCta,
    postSidebar__cta,
    postSidebar__ctaBtn,    
    postSidebar__ctaCard,
    postSidebar__ctaTitle,
    postSidebar__ctaBtnWrap,
    postSidebar__ctaButton,
    postSidebar__ctaBtnOuter,
    postSidebar__ctaImage,
    postSidebar__ctaTitleMob,
    postSidebar__imgBtn,
    postSidebar__tocHeightSmall,
    postSidebar__tocHeightHigh,
    postSidebar__titleWrap,
    postSidebar__tocClose,
    postSidebar__tocFixedMobile,
} = styles;

const PostSidebar = ({ headings, ctas, cta }) => {
  const { t } = useTranslation();
  const [isFixed, setIsFixed] = useState(false);
  const [isTopCta, setIsTopCta] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const [isTocTall, setIsTocTall] = useState(false);
  const [isTocVeryTall, setIsTocVeryTall] = useState(false);
  const [scrollDisabled, setScrollDisabled] = useState(false);
  const [isTocOpen, setIsTocOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1140);
    checkMobile();

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const postAuthor = document.querySelector('#post-author');
    const postSidebar = document.querySelector('#post-sidebar');
    const postSidebarTopCta = document.querySelector('#sidebar-top-cta');
    const postSidebarToc = document.querySelector('#post-sidebar-toc');
    const postSidebarTopCtaHeight = postSidebarTopCta.offsetHeight;
    const postSidebarTocHeight = postSidebarToc.offsetHeight;
    const postContent = document.querySelector('#grid-content');
    const footer = document.querySelector('footer');
    const postContentOffset = postContent.offsetTop;
    const postSidebarOffset = 100;
    const trainingInfoBottom =
      window.innerHeight - (postSidebar.offsetHeight + postSidebarOffset);
    const authorPadding = 60;

    if (postSidebarTopCtaHeight > 0) {
      setIsTopCta(true);
    } else {
      setIsTopCta(false);
    }

    if (postSidebarTocHeight >= 320) {
      setIsTocTall(true);
    } else {
      setIsTocTall(false);
    }

    if (postSidebarTocHeight >= 500) {
      setIsTocVeryTall(true);
    } else {
      setIsTocVeryTall(false);
    }

    const handleScroll = () => {
      const elementTop = postAuthor ? postAuthor.offsetTop : footer.offsetTop;
      const viewportTop = window.scrollY || document.documentElement.scrollTop;
      const viewportBottom = viewportTop + window.innerHeight;

      if (window.innerWidth < 1140) {
        setIsFixed(false);
        postSidebar.classList.remove(postSidebarBottom);
        postSidebar.style.bottom = 'auto';
        return;
      }

      const sideBarMarginTop = postSidebarTopCtaHeight + 50;
      const scrollableHeight = viewportTop + postSidebarOffset;
      const adjustedMargin = postSidebarTopCtaHeight > 0 ? sideBarMarginTop : 0;

      if (postContentOffset < scrollableHeight + adjustedMargin) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }

      if (elementTop < viewportBottom - trainingInfoBottom + authorPadding) {
        postSidebar.classList.add(postSidebarBottom);
        const bottomFix = viewportBottom - elementTop + authorPadding;
        postSidebar.style.bottom = `${bottomFix}px`;
        return;
      }
      postSidebar.classList.remove(postSidebarBottom);
      postSidebar.style.bottom = 'auto';
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollDisabled) {
        const scrollPosition = window.scrollY;

        headings.forEach((section, index) => {
          const element = document.getElementById(index);

          if (element) {
            const sectionTop = element.offsetTop - 300;
            const sectionHeight = element.offsetHeight;

            if (
              scrollPosition >= sectionTop &&
              scrollPosition < sectionTop + sectionHeight
            ) {
              setActiveLink(index);
            }
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [headings, scrollDisabled]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      if (isTopCta) {
        const postGridSidebar = document.querySelector('#postgrid-sidebar');
        if (!postGridSidebar) return;

        if (window.innerWidth < 1140) {
          postGridSidebar.style.marginTop = '0px';
        } else {
          const postSidebarTopCta = document.querySelector('#sidebar-top-cta');
          if (!postSidebarTopCta) return;

          const postSidebarTopCtaHeight = postSidebarTopCta.offsetHeight;
          const sideBarMarginTop = postSidebarTopCtaHeight + 50;
          postGridSidebar.style.marginTop = `-${sideBarMarginTop}px`;
        }
      }
    };
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isTopCta]);

  const handleClick = (id) => {
    setScrollDisabled(true);
    setActiveLink(id);

    setTimeout(() => {
      setScrollDisabled(false);
    }, 500);
  };

  return (
    <>
      <section
        className={`${postSidebar} ${isFixed ? postSidebarFixed : ''}`}
        id="post-sidebar"
      >
        <div className={postSidebar__topCta} id="sidebar-top-cta">
          {ctas && ctas.length > 0 && (
            <div>
              {ctas.map((item, index) => (
                <div
                  key={index}
                  id={`cta-${index}`}
                  className={postSidebar__ctaCard}
                >
                  <h4 className={postSidebar__ctaTitle}>{item.title}</h4>
                  <div className={postSidebar__imgBtn}>
                    {item.image?.gatsbyImageData && (
                      <GatsbyImage
                        image={getImage(item.image.gatsbyImageData)}
                        alt={item.image.title || ''}
                        className={postSidebar__ctaImage}
                      />
                    )}
                    <div className={postSidebar__ctaBtnOuter}>
                      <h4 className={postSidebar__ctaTitleMob}>{item.title}</h4>
                      {item.cta && (
                        <div className={postSidebar__ctaBtnWrap}>
                          <a
                            href={item.cta.url}
                            className={postSidebar__ctaButton}
                          >
                            {item.cta.label}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div
          className={`
        ${postSidebar__toc}
        ${isTopCta && isTocTall ? postSidebar__tocHeightSmall : ''}
        ${!isTopCta && isTocVeryTall ? postSidebar__tocHeightHigh : ''}
      `}
          id="post-sidebar-toc"
        >
          <div
            className={`${postSidebar__titleWrap} ${
              isTocOpen || !isMobile ? '' : postSidebar__tocClose
            }`}
          >
            <p className={postSidebar__title}>{t('blog_post_jump_to')}</p>
            {isMobile && (
              <button
                onClick={() => setIsTocOpen(!isTocOpen)}
                className={styles.postSidebar__tocToggle}
                aria-label="Toggle Table of Contents"
              >
                {/* Replace with your actual SVG icon */}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {isTocOpen ? (
                    <path
                      d="M18 15L12 9L6 15"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  ) : (
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  )}
                </svg>
              </button>
            )}
          </div>
          {(isTocOpen || !isMobile) && (
            <>
              <div className={postSidebar__links}>
                {headings.map((heading, index) => (
                  <a
                    href={`#${index}`}
                    className={`${postSidebar__link} ${
                      activeLink === index ? postSidebar__linkActive : ''
                    }`}
                    key={index}
                    onClick={() => handleClick(index)}
                  >
                    {heading.content[0].value}
                  </a>
                ))}
              </div>
              {cta && (
                <div className={postSidebar__cta}>
                  <a href={cta.url} className={postSidebar__ctaBtn}>
                    {cta.label}
                  </a>
                </div>
              )}
            </>
          )}
        </div>
        <PostFooterSocial />
      </section>
    </>
  );
}

export default PostSidebar;

